import { CHARACTER_WHITESPACE } from '../../../constants/common'

import { MERMAID_LANGUAGE_CLASS_NAME } from './GretaAIChatMermaid.constants'

export function getIsGretaAIChatMermaid(className) {
  return Boolean(
    className?.split(CHARACTER_WHITESPACE).includes(MERMAID_LANGUAGE_CLASS_NAME)
  )
}
